var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2675_5807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.5V6.5C14.5 5.96957 14.2893 5.46086 13.9142 5.08579C13.5391 4.71071 13.0304 4.5 12.5 4.5H5.5C4.96957 4.5 4.46086 4.71071 4.08579 5.08579C3.71071 5.46086 3.5 5.96957 3.5 6.5V18.5C3.5 19.0304 3.71071 19.5391 4.08579 19.9142C4.46086 20.2893 4.96957 20.5 5.5 20.5H12.5C13.0304 20.5 13.5391 20.2893 13.9142 19.9142C14.2893 19.5391 14.5 19.0304 14.5 18.5V16.5",
    stroke: "#F1F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5H21.5L18.5 9.5",
    stroke: "#F1F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.5L21.5 12.5",
    stroke: "#F1F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2675_5807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.f46cf22394e3ebda9806b917b15537ee.svg";
export { ForwardRef as ReactComponent };